




























import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

type actStatus = 'open' | 'close'
@Component({
  name: 'DeveloperWeekConfig'
})
export default class extends mixins(DateOption) {
  // api data
  private freeCount: number = 0
  private vipCount: number = 0
}
